import {
  ShieldCheck, Globe, Users, Award, Handshake, Layers,
  GraduationCap, Building2, Leaf, Brain, Lock, Zap,
  Check, ArrowRight
} from "lucide-react";

export const PARTNERS_HERO = {
  eyebrow: "Our Partners",
  headline: "Strong Ecosystems Build Stronger Solutions",
  subheadline:
    "For over three decades, Asterisk has cultivated strategic partnerships that strengthen our ability to deliver secure, scalable, and future-ready solutions for SMEs across Singapore and Asia Pacific.",
};

export const PARTNERS_MICROSOFT = {
  headline: "Microsoft Partnership",
  subtitle: "More Than Two Decades of Collaboration",
  description:
    "Asterisk is proud to be one of Singapore's longest-standing Microsoft solution partners, with a relationship spanning more than 24 years.",
  achievements: [
    "Implemented Microsoft ERP solutions across multiple industries",
    "Evolved from early on-premise systems to cloud-native architectures",
    "Delivered Microsoft Business Applications to over 100 organisations",
    "Achieved recognition as a Microsoft Solutions Partner (Business Applications)",
    "Published industry-specific solutions in Microsoft AppSource",
  ],
  qualities: [
    "Technical competence",
    "Consistent delivery standards",
    "Governance maturity",
    "Long-term client success",
  ],
};

export const PARTNERS_SOLUTION = [
  { name: "Crayon Software", type: "Software and Cloud Distribution Partner", logo: "/assets/partners/crayon.png" },
  { name: "Pax8", type: "Software and Cloud Distribution Partner", logo: "/assets/partners/pax8.png" },
  { name: "LeeCare", type: "Long-Term Care Clinical System Partner", logo: "/assets/partners/leecare.png" },
  { name: "PulseSync", type: "Long-Term Care Clinical System Partner", logo: "/assets/partners/pulsesync.png" },
  { name: "VGC Technologies", type: "Cloud Infrastructure and Security Partner", logo: "/assets/partners/vgc.png" },
  { name: "Apper Cloud Labs", type: "AI Infrastructure, Cloud & Security Partner", logo: "/assets/partners/apper-cloud-labs.webp", url: "https://apper.cloud/" },
];

export const PARTNERS_REGIONAL = {
  headline: "Regional AI & Innovation Networks",
  subtitle: "Singapore Leadership. ASEAN Delivery Strength.",
  locations: ["Singapore", "Malaysia", "Vietnam", "Philippines"],
  capabilities: [
    "Scalable AI development capacity",
    "Cost-efficient engineering models",
    "Cross-border solution deployment",
    "Shared talent pools",
    "Continuous research collaboration",
  ],
};

export const PARTNERS_UNIVERSITY = {
  headline: "University & Talent Ecosystem Collaborations",
  engagements: ["Local universities", "Regional academic institutions", "Internship and mentorship programmes", "Research and applied innovation collaborations"],
  outcomes: ["Develop future-ready AI and ERP specialists", "Stay aligned with emerging research", "Contribute real-world case studies into academic environments", "Build structured internship pathways"],
};

export const PARTNERS_INDUSTRY = {
  headline: "Industry Associations & Public Sector Engagement",
  sectors: ["Healthcare long-term care institutions", "Non-profit organisations", "Government-linked initiatives", "Sustainability-driven enterprises", "Industry modernisation programmes"],
  outcomes: ["Stay aligned with regulatory developments", "Contribute to sector-specific digital transformation dialogues", "Deliver solutions aligned with public policy frameworks", "Support SME readiness initiatives"],
};

export const PARTNERS_TECH = {
  headline: "Technology & Cloud Infrastructure Alliances",
  types: ["Cloud infrastructure providers", "Cybersecurity specialists", "Data governance advisors", "Automation and AI tooling platforms"],
  criteria: ["Security standards", "Compliance capability", "Scalability", "Long-term viability"],
};

export const PARTNERS_WHY = [
  "Enterprise-grade platforms",
  "Regional deployment capability",
  "Cross-domain expertise",
  "Faster innovation cycles",
  "Strong governance alignment",
  "Long-term technology stability",
];

export const PARTNERS_JOIN = [
  "A technology provider",
  "A university or research institution",
  "An industry association",
  "A cloud or AI platform partner",
  "A sustainability initiative leader",
];
